export default __webpack_public_path__ + "static/media/Mob-responsive-720x540-px_gold-and-silver-NFO.b7204b24.jpeg";